<template>
	<ChooseCredentials
		:credsServiceWorkspaceIsWrong="credsServiceWorkspaceIsWrong"
		:selectedApp="selectedApp"
		v-bind="{ ...$props, ...$attrs }"
		v-on="$listeners"
	/>
</template>

<script>
import ChooseCredentials from './ChooseCredentials.vue';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { getAccountConnection } from '@/store/modules/credentials/getters';
import props from './ChooseCredentialsDataProvider.props';
import { getService } from '@/store/modules/apps/getters';

export default {
	name: 'ChooseCredentialsDataProvider',
	props,
	components: { ChooseCredentials },
	computed: {
		...mapGettersShorthand({ getAccountConnection, getService }),
		credentials() {
			return this.getAccountConnection(this.profileId);
		},
		selectedApp() {
			return this.getService(this.selectedAppId);
		},
		profileId() {
			return this.selectedCredentialsConfiguration.id;
		},
		credsServiceWorkspaceIsWrong() {
			if (!!this.selectedServiceWorkspaceId && !!this.credentials?.service_workspace) {
				// we can tell if its wrong, only if we came with selectedServiceWorkspaceId and we have service_workspace_id on credentials
				return this.selectedServiceWorkspaceId !== this.credentials.service_workspace.workspace_id;
			}
			return false;
		},
	},
};
</script>

<style lang="scss"></style>
